import { initiativesJiraIssueAddSyncSlice } from '../@sync/add';
import { putInitiativesLinkJira } from '@api';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createPutAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const putJiraInitiativesLinkIssueSlice = createPutAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.JIRA_ISSUE_LINKED, (action) => action.data),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				initiativesJiraIssueAddSyncSlice.syncActionCreator({
					isSynced: false,
					issueKey: request.issueKey,
					issueName: request.issueName,
					issueStatusId: request.statusId,
					projectKey: request.projectKey
				})
		]
	},
	name: 'jiraInitiativesLinkIssue',
	receive: false,
	request: true,
	requestHandler: putInitiativesLinkJira
});
